import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SUGGEST_LIST } from 'manager/http-constants';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { PlatformComponent } from '../platform.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-c502',
  templateUrl: './c502.component.html',
  styleUrls: ['./c502.component.scss', '../platform.component.scss'],
})

/**
 * マッチング依頼一覧
 */
export class C502Component extends PlatformComponent {
  // 画面.検索フォーム
  c502SearchForm: FormGroup = this.formBuilder.group({
    member_id: CONSTANT.EMPTY_STRING,
    //ステータス・ シングルセレクト
    status: '9',
    // 期間日from
    date1: CONSTANT.EMPTY_STRING,
    // 期間日to
    date2: CONSTANT.EMPTY_STRING,
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  //ステータス取得格納先
  statusList: object[] = [
    {
      sp_name: '全て',
      sp_code: '9',
    },
    {
      sp_name: '未回答',
      sp_code: '0',
    },
    {
      sp_name: '検討中',
      sp_code: '1',
    },
    {
      sp_name: '見送り/辞退（理由１）',
      sp_code: '2',
    },
    {
      sp_name: '見送り/辞退（理由２）',
      sp_code: '3',
    },
    {
      sp_name: '見送り（理由３）',
      sp_code: '4',
    },
    {
      sp_name: '意見交換希望',
      sp_code: '5',
    },
  ];

  // 検索結果一覧表示
  resultTaskDataList: object[] = new Array();

  // 件数格納先
  countTaskData: number = 0;

  // セッション保存名
  sessionTagName: string = 'c502SearchConditions';

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 提案結果を取得
    this.getResultTaskDataList();
  }

  /**
   * 課題・ソリューション結果を取得
   * @param c502SearchForm 検索条件
   */
  public getResultTaskDataList(screenSearchFlg?: boolean): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let c502SearchForm: any = JSON.parse(
      JSON.stringify(this.c502SearchForm.value)
    );
    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if(!this.checkSetConditions(c502SearchForm) && !screenSearchFlg){
      let sessionSearchForm = JSON.parse(sessionStorage.getItem(this.sessionTagName));
      // セッションに値がなければ設定しない
      if(this.checkSetConditions(sessionSearchForm)){
        // 画面の検索条件に反映する
        this.c502SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        c502SearchForm = JSON.parse(
          JSON.stringify(this.c502SearchForm.value)
        );
      }
    }

    c502SearchForm.member_id = this.getLoginMemberId();

    if (!c502SearchForm.status) {
      c502SearchForm.status = '9';
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUGGEST_LIST);

    // 提案検索結果を取得
    this.dbOperationService
      .getNoTemplateData(SUGGEST_LIST, c502SearchForm, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 提案検索結果結果を格納
          this.resultTaskDataList = response.body;
        } else {
          this.resultTaskDataList = new Array();
        }

        // 検索条件を保持
        sessionStorage.setItem(this.sessionTagName, JSON.stringify(this.c502SearchForm.value));

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUGGEST_LIST);
      });

    // テーブル状態が存在するか否か
    if (this.table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      this.table.reset();
    }
  }

  /**
   * 検索条件を削除
   */
  public clearConditions(): void {
      // 検索条件を削除
      this.c502SearchForm.reset();
      this.c502SearchForm.setValue({member_id: '', status:'9', date1:'', date2: ''});
  }

  /**
   * マッチング提案掲示板(C601)へ遷移する
   * @param suggestId 提案ID
   */
  public moveC601(suggestId: string): void {
    // マッチング提案掲示板(C601)へ遷移
    this.router.navigate(['pages/platform/c601/' + suggestId]);
  }

  /**
   * 検索条件が設定されているかチェックする
   * @param conditions
   * @returns boolean true:設定あり / false:未設定
   */
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if(conditions === undefined || conditions === null){
      return false;
    } else {
      // 検索条件が設定されているかチェック(ステータスは標準で9をとってしまうため)
      if("9" != conditions["status"] || conditions["date1"] || conditions["date2"] || conditions["member_id"]){
        return true;
      }
    }
    return false;
  }
}
